import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=10953804&scoped=true&"
import script from "./homePage.vue?vue&type=script&lang=js&"
export * from "./homePage.vue?vue&type=script&lang=js&"
import style0 from "./homePage.vue?vue&type=style&index=0&id=10953804&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10953804",
  null
  
)

export default component.exports